import { render, staticRenderFns } from "./relevance-form.vue?vue&type=template&id=b88be4ea&scoped=true&"
import script from "./relevance-form.vue?vue&type=script&lang=ts&"
export * from "./relevance-form.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form.vue?vue&type=style&index=0&lang=less&"
import style1 from "./relevance-form.vue?vue&type=style&index=1&id=b88be4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88be4ea",
  null
  
)

export default component.exports